function formatDelimiters(
  number = 0,
  precision = 2,
  thousands = ',',
  decimal = '.',
) {
  if (isNaN(number) || number == null) {
    return 0
  }

  const moneyParts = (number / 100.0).toFixed(precision).split('.')
  const dollars = moneyParts[0].replace(
    /(\d)(?=(\d\d\d)+(?!\d))/g,
    `$1${thousands}`,
  )
  const cents = moneyParts[1] ? `${decimal}${moneyParts[1]}` : ''

  return `${dollars}${cents}`
}

export function FormatMoney(amount, suppressCurrencyCode = false) {
  if (typeof amount === 'string') {
    amount = amount.replace('.', '')
  }

  const shopifyMoneyFormatRegex = /\{\{\s*(\w+)\s*}}/
  const format =
    suppressCurrencyCode ?
      SAXX.Shop.MoneyFormat
    : SAXX.Shop.MoneyFormatWithCurrency

  let value
  switch (format.match(shopifyMoneyFormatRegex)[1]) {
    case 'amount_no_decimals':
      value = formatDelimiters(amount, 0)
      break
    case 'amount_with_comma_separator':
      value = formatDelimiters(amount, 2, '.', ',')
      break
    case 'amount_no_decimals_with_comma_separator':
      value = formatDelimiters(amount, 0, '.', ',')
      break
    case 'amount_with_space_separator':
      value = formatDelimiters(amount, 2, ' ', ',')
      break
    case 'amount_with_apostrophe_separator':
      value = formatDelimiters(amount, 2, "'", ',')
      break
    default:
      value = formatDelimiters(amount, 2)
  }

  return format.replace(shopifyMoneyFormatRegex, value)
}

export function FormatMoneyAmount(amount) {
  return Intl.NumberFormat(`en-${Shopify.country}`, {
    style: 'currency',
    currency: Shopify.currency.active,
    currencyDisplay: 'code',
  })
    .format(amount)
    .replace(Shopify.currency.active, '')
    .replace(',', '')
    .trim()
}
